import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { GridStore } from '../stores/grid/grid.state';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';
import { getState } from '@ngrx/signals';

/**
 * Guard that prevents the user from navigating away from a route or to a sibling route
 * if there are unsaved changes in the GridStore. It shows a confirmation dialog
 * if changes are detected.
 *
 * @return {CanActivateFn | CanDeactivateFn<any>} The functional guard.
 */
export const unsavedChangesGuard:
    | CanActivateFn
    | CanDeactivateFn<any> = async () => {
        const gridStore = inject(GridStore);
        const confirmationService = inject(ConfirmationDialogService);

        console.log('unsavedChangesGuard call');
        console.log(getState(gridStore));

        if (gridStore.layout().length === 0 || !gridStore.gridHasChanges()) {
            console.log('unsavedChangesGuard: No changes detected.');
            return true;
        }

        const result = await confirmationService.confirmAtlasOverwritePromise(
            'Ungespeicherte Änderungen',
            'Ihre aktuelle Ansicht enthält ungespeicherte Änderungen. Möchten Sie diese verwerfen und fortfahren?'
        );

        if (result) {
            console.log('unsavedChangesGuard: Changes reset.');
            setTimeout(() => {
                gridStore.resetGridHasChanges();
            }, 1000);
        }

        return result;
    };
